export const SHORTCUTS = {
  SEARCH_PATIENTS: 'Mod+K',
  PATIENTS: 'Alt+1',
  ACTIVITY: 'Alt+2',
  PRODUCTION: 'Alt+3',
  CONFIGURATION: 'Alt+0',
  BACK: 'Alt+ArrowLeft',
  CLOSE_MODAL: 'Escape',
  CHEAT_SHEET: 'Mod+/',
  NAVIGATE_ROW_UP: 'ArrowUp',
  NAVIGATE_ROW_DOWN: 'ArrowDown',
  VIEW_ROW_PAGE: 'Alt+V',
  VIEW_ROW_PAGE_NEW_TAB: 'Alt+Shift+V',
} as const
